<template>
    <div class="updates-and-insights mt-5">
        <template v-if="isBuilt">
            <div v-if="reloading" class="spinner element-spinner chatGPT d-flex flex-column justify-content-center align-items-center">
                <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
            </div>
            <div class="row justify-content-center">
                <div class="col">
                    <h1 class="section-highlights serif">{{updatesAndInsightsData.name}}
                        <button v-if="!editUpdatesInsights && getUserPermissions().edit_reports && !isGuest" class="btn btn-secondary edit" :class="{'hasGPT':!isArchive && !hasData}" @click="editUpdatesInsightsData">Edit</button>
                    </h1>
                    <span class="h-line"></span>
                </div>
            </div>
            <div v-if="editUpdatesInsights" class="row justify-content-center mt-5 mb-3" :class="{'not-showing': !showUpdatesInsights}">
                <transition name="fade-edit">
                    <div v-if="!isGuest" v-show="showUpdatesInsights" class="col">
                        <div class="row mb-5">
                            <div class="col updates-insights-wrap" data-updates-insights="update1">
                                <label class="font-weight-bold">Box1 Title: </label>
                                <input v-model="box1_title" type="text" class="box w-25" name="box1_title" />
                                <label class="font-weight-bold">Title 1: </label>
                                <input v-model="title_1" type="text" class="title w-25" name="title_1" />
                                <h6 class="font-weight-bold my-2">Body 1: </h6>
                                <textarea class="froala-updates-insights highlight_1">{{body_1}}</textarea>
                            </div>
                        </div>
                        <div class="row mb-5">
                            <div class="col updates-insights-wrap" data-updates-insights="update2">
                                <label class="font-weight-bold">Box2 Title: </label>
                                <input v-model="box2_title" type="text" class="box w-25" name="box2_title" />
                                <label class="font-weight-bold">Title 2: </label>
                                <input v-model="title_2" type="text" class="title w-25" name="title_2" />
                                <h6 class="font-weight-bold my-2">Body 2: </h6>
                                <textarea class="froala-updates-insights highlight_2">{{body_2}}</textarea>
                            </div>
                        </div>
                        <div class="row mb-5">
                            <div class="col updates-insights-wrap" data-updates-insights="update3">
                                <label class="font-weight-bold">Box3 Title: </label>
                                <input v-model="box3_title" type="text" class="box w-25" name="box3_title" />
                                <label class="font-weight-bold">Title 3: </label>
                                <input v-model="title_3" type="text" class="title w-25" name="title_3" />
                                <h6 class="font-weight-bold my-2">Body 3: </h6>
                                <textarea class="froala-updates-insights highlight_3">{{body_3}}</textarea>
                            </div>
                        </div>
                        <div class="row mb-5">
                            <div class="col updates-insights-wrap" data-updates-insights="update4">
                                <label class="font-weight-bold">Box4 Title: </label>
                                <input v-model="box4_title" type="text" class="box w-25" name="box4_title" />
                                <label class="font-weight-bold">Title 4: </label>
                                <input v-model="title_4" type="text" class="title w-25" name="title_4" />
                                <h6 class="font-weight-bold my-2">Body 4: </h6>
                                <textarea class="froala-updates-insights highlight_4">{{body_4}}</textarea>
                            </div>
                        </div>
                        <div class="row">
                            <template v-if="hasArchive">
                                <div class="col">
                                    <button class="btn btn-secondary reverse float-right ml-3" @click="closeUpdatesInsights">Close</button>
                                    <button class="btn btn-secondary float-right" @click="saveUpdatesInsights">Save</button>
                                </div>
                            </template>
                            <template v-else>
                                <div class="col-md-6">
                                    <label class="font-weight-bold">Select a name for the archive: </label>
                                    <input v-model="archive_name" type="text" class="archive w-50" name="archive_name" />
                                </div>
                                <div class="col-md-6">
                                    <button class="btn btn-secondary reverse float-right ml-3" @click="closeUpdatesInsights">Close</button>
                                    <button class="btn btn-secondary float-right" @click="saveUpdatesInsights">Save</button>
                                </div>
                            </template>
                        </div>
                    </div>
                </transition>
            </div>
            <transition name="fade-highlights">
                <div v-if="!editUpdatesInsights" class="row row-cols-1 row-cols-md-2 row-justify-content-center mt-5">
                    <template v-if="errors">
                        <div class="empty-data"><img :src="$store.state.app_url+'/images/errors.gif'"></div>
                    </template>
                    <template v-else>
                        <div v-for="(update_insight, index) in updates_insights" class="col-12 d-flex flex-column justify-content-center" :class="index < 2 ? box_cls1 : box_cls2">
                            <fieldset class="bordered flex-grow-1" :class="'card'+(index+1)">
                                <legend v-html="update_insight.boxTitle" class="bordered" :class="{'empty':!update_insight.boxTitle}" align="center">{{update_insight.boxTitle}}</legend>
                                <div class="row justify-content-center my-3">
                                    <div class="col m-xs-1 px-lg-5 m-lg-5 fr-text">
                                        <h1 v-html="update_insight.title" class="text-center insight-title">{{update_insight.title}}</h1>
                                        <h4 v-html="update_insight.body" class="text-center mt-2">
                                            {{update_insight.body}}
                                        </h4>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </template>
                </div>
            </transition>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['isBuilt', 'updatesAndInsightsData', 'isGuest', 'hasSkb'],
        created() {
            this.dateFrom        = vm.$dayjs(this.$store.state.current_dates.date_from).format("DD-MM-YYYY");
            this.dateTo          = vm.$dayjs(this.$store.state.current_dates.date_to).format("DD-MM-YYYY");
            this.dateCompareFrom = vm.$dayjs(this.$store.state.current_dates.date_compare_from).format("DD-MM-YYYY");
            this.dateCompareTo   = vm.$dayjs(this.$store.state.current_dates.date_compare_to).format("DD-MM-YYYY");
            if (this.isBuilt) {
                this.isArchive = this.$store.state.isArchive;
                this.prefixed_id = this.isArchive ? this.updatesAndInsightsData.archive_id : this.updatesAndInsightsData.report_id;
                this.fetchServerData();
                event_bus.$on('archive_name', (archive_name) => {
                    this.archive_name = archive_name;
                    this.hasArchive = true;
                });
            }
        },
        data() {
            return {
                isArchive: null,
                updates_insights: [],
                num_boxes:0,
                box_cls1:'col-md-6',
                box_cls2:'col-md-6',
                editUpdatesInsights: false,
                showUpdatesInsights: false,
                dateFrom:null,
                dateTo:null,
                dateCompareFrom:null,
                dateCompareTo:null,
                box1_title: '',
                box2_title: '',
                box3_title: '',
                box4_title: '',
                title_1: '',
                title_2: '',
                title_3: '',
                title_4: '',
                body_1: '',
                body_2: '',
                body_3: '',
                body_4: '',
                errors:false,
                hasArchive:false,
                hasData:false,
                archive_name:null,
                reloading: false
            }
        },
        mounted(){
            event_bus.$on('reloading', () => {
                this.resetData();
                this.fetchServerData();
            });
        },

        methods: {
            resetData(){
                this.box1_title = '';
                this.box2_title = '';
                this.box3_title = '';
                this.box4_title = '';
                this.title_1 = '';
                this.title_2 = '';
                this.title_3 = '';
                this.title_4 = '';
                this.body_1 = '';
                this.body_2 = '';
                this.body_3 = '';
                this.body_4 = '';
                this.updates_insights = [];
                this.num_boxes = 0;
            },
            fetchServerData() {
                if(this.reloading) return;
                this.reloading = true;
                let params = {
                    'isArchive':            this.isArchive,
                    'prefixed_id':          this.prefixed_id,
                    'client_id':            this.updatesAndInsightsData.client_id,
                    'element_abbr':         this.updatesAndInsightsData.element_abbreviation,
                    'dwm':                  this.$store.state.current_dwm,
                    'date_from':            this.$store.state.current_dates.date_from,
                    'date_to':              this.$store.state.current_dates.date_to,
                    'date_compare_from':    this.$store.state.current_dates.date_compare_from,
                    'date_compare_to':      this.$store.state.current_dates.date_compare_to,
                    'element_id':           this.updatesAndInsightsData.element_id,
                    'report_element_id':    this.updatesAndInsightsData.report_element_id,
                    'element_name':         this.updatesAndInsightsData.name
                };
                params = encodeURIComponent(JSON.stringify(params));
                this.updates_insights = [];
                this.num_boxes=0;
                if (this.$store.state.isArchive) {
                    axios.get(`/api/reporting/updates_insights/${this.$route.params.archive_id}/?params=${params}`).then((updatesAndInsightsData) => {
                        if (updatesAndInsightsData.data) {
                            this.hasArchive = updatesAndInsightsData.data.hasArchive;
                            this.errors = updatesAndInsightsData.data.errors;
                            if(this.hasArchive){
                                this.archive_name = updatesAndInsightsData.data.archive_name;
                            }
                            _.each(updatesAndInsightsData.data, (updatesInsights, index) => {
                                if (updatesInsights.body) {
                                    this.updates_insights.push(updatesInsights);
                                }
                                this['box' + index.substr(-1, 1) + '_title'] = updatesAndInsightsData.data[index]['boxTitle'];
                                this['title_' + index.substr(-1, 1)] = updatesAndInsightsData.data[index]['title'];
                                this['body_' + index.substr(-1, 1)] = updatesAndInsightsData.data[index]['body'];
                                this.hasData = true;
                            });
                        }
                        this.num_boxes = this.updates_insights.length;
                        this.reloading = false;
                    });
                }
                else {
                    axios.get(`/api/reporting/updates_insights/${this.$route.params.report_id}/?params=${params}`).then((updatesAndInsightsData) => {
                        if (updatesAndInsightsData.data) {
                            this.hasArchive = updatesAndInsightsData.data.hasArchive;
                            this.errors = updatesAndInsightsData.data.errors;
                            if(this.hasArchive){
                                this.archive_name = updatesAndInsightsData.data.archive_name;
                            }
                            _.each(updatesAndInsightsData.data, (updatesInsights, index) => {
                                if (updatesInsights.body) {
                                    this.updates_insights.push(updatesInsights);
                                }
                                this['box' + index.substr(-1, 1) + '_title'] = updatesAndInsightsData.data[index]['boxTitle'];
                                this['title_' + index.substr(-1, 1)] = updatesAndInsightsData.data[index]['title'];
                                this['body_' + index.substr(-1, 1)] = updatesAndInsightsData.data[index]['body'];
                            });
                        }
                        this.num_boxes = this.updates_insights.length;
                        this.reloading = false;
                    });
                }
            },
            updateBoxClasses(){
                if(this.num_boxes == 1){
                    this.box_cls1 = 'col-md-12';
                    this.box_cls2 = 'col-md-12';
                }
                else if(this.num_boxes == 3){
                    this.box_cls1 = 'col-md-6';
                    this.box_cls2 = 'col-md-12';
                }
                else{
                    this.box_cls1 = 'col-md-6';
                    this.box_cls2 = 'col-md-6';
                }
            },
            editUpdatesInsightsData() {
                const report_element_id = this.updatesAndInsightsData.report_element_id;
                let params = {
                    'prefixed_id':          this.prefixed_id,
                    'client_id':            this.updatesAndInsightsData.client_id,
                    'element_abbr':         this.updatesAndInsightsData.element_abbreviation,
                    'element_id':           this.updatesAndInsightsData.element_id,
                    'report_element_id':    this.updatesAndInsightsData.report_element_id,
                    'element_name':         this.updatesAndInsightsData.name,
                    'date_from':            this.$store.state.current_dates.date_from,
                    'date_to':              this.$store.state.current_dates.date_to,
                    'date_compare_from':    this.$store.state.current_dates.date_compare_from,
                    'date_compare_to':      this.$store.state.current_dates.date_compare_to,
                };
                event_bus.$emit('show_chatGPT', params);

                axios.get(`/api/reporting/ui_need_refresh/${report_element_id}`).then((response) => {
                    if(response.data.success == false){
                        const message = "Something changed in the builder, so you need a page refresh before editing this element."
                        this.notification(message, 'type-warning', 'INFORMATION', BootstrapDialog.SIZE_SMALL, 5000, function(){location.reload()});
                    }
                    else{
                        this.editUpdatesInsights = true;
                        this.openUpdatesInsightsFroalaEditor();
                    }
                });
            },

            openUpdatesInsightsFroalaEditor() {
                const vueInstance = this;
                setTimeout(function () {
                    $('#reporting_view').find('.froala-updates-insights').off('froalaEditor.initialized').froalaEditor({
                        key: 'AA12B9A4A4xC2D2F2B2A29A3C3A8B1D2sg1Ti1LXd2URVJh1DWXG==',
                        height: 200,
                        charCounterCount: false,
                        requestWithCORS: false,
                        htmlExecuteScripts: false,
                        htmlUntouched: true,
                        htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'b', 'base', 'blockquote', 'br', 'button', 'caption', 'cite', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'div', 'dl', 'dt', 'em', 'fieldset', 'figcaption', 'figure', 'footer', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'img', 'ins', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'nav', 'ol', 'optgroup', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 's', 'section', 'small', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'tfoot', 'th', 'thead', 'title', 'tr', 'u', 'ul'],
                        htmlRemoveTags: ['script', 'form', 'style', 'iframe', 'input', 'select', 'option', 'video', 'audio', 'canvas', 'code', 'object', 'keygen'],
                        toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough', 'subscript', 'superscript', 'fontFamily', 'fontSize', 'color', 'formatOL', 'formatUL', 'insertLink', 'insertTable', 'specialCharacters', 'insertHR', 'selectAll', 'clearFormatting', 'undo', 'redo'],
                        fontFamily: {
                            "Arial, Helvetica, sans-serif": 'Arial',
                            "Georgia, serif": 'Georgia',
                            "Impact, Charcoal, sans-serif": 'Impact',
                            "Tahoma, Geneva, sans-serif": 'Tahoma',
                            "Times New Roman, Times, serif": 'Times New Roman',
                            "Verdana, Geneva, sans-serif": 'Verdana',
                            "BentonSans Regular": 'BentonSans Regular',
                        }
                    });
                    vueInstance.showUpdatesInsights = true;
                }, 400);
            },
            saveUpdatesInsights() {
                let updates_insights = {};
                $('#reporting_view').find('div.updates-insights-wrap').each(function (idx, el) {
                    const $el = $(el);
                    const boxTitle = $el.find('input.box').val();
                    const title = $el.find('input.title').val();
                    const body = $el.find('.froala-updates-insights').froalaEditor('html.get', true);

                    updates_insights[$el.attr('data-updates-insights')] = {'boxTitle': boxTitle, 'title': title, 'body': body};
                });

                const prefixed_id = this.isArchive ? this.$route.params.archive_id : this.$route.params.report_id;
                const report_element_id = this.updatesAndInsightsData.report_element_id;

                axios.post(`/api/reporting/updates_insights`, {
                    isArchive:              this.isArchive,
                    prefixed_id:            prefixed_id,
                    report_element_id:      report_element_id,
                    client_id:              this.updatesAndInsightsData.client_id,
                    date_from:              this.$store.state.current_dates.date_from,
                    date_to:                this.$store.state.current_dates.date_to,
                    date_compare_from:      this.$store.state.current_dates.date_compare_from,
                    date_compare_to:        this.$store.state.current_dates.date_compare_to,
                    updates_insights:       updates_insights,
                    hasArchive:             this.hasArchive,
                    archive_name:           this.archive_name,
                    hasSkb:                 this.hasSkb
                }).then((response) => {
                    if(response.data['need_refresh']){
                        const message = "This report have been modified in the builder and cannot be saved without losing this text. You will need to open a new version of this report and edit it again."
                        this.notification(message, 'type-warning', 'INFORMATION', BootstrapDialog.SIZE_SMALL, 20000);
                    }
                    else{
                        this.$notify({
                            type: 'success',
                            text: response.data['exists'] == true ? this.messages.HIGHLIGHTS_UPDATED : this.messages.HIGHLIGHTS_CREATED
                        });

                        const updatesAndInsightsData = response.data['updates_insights'];
                        this.editUpdatesInsights = false;
                        this.showUpdatesInsights = false;
                        this.hasArchive = true;
                        this.updates_insights = [];
                        _.each(updatesAndInsightsData, (updatesInsights, index) => {
                            if (updatesInsights.body) {
                                this.updates_insights.push(updatesInsights);
                            }
                            this['box' + index.substr(-1, 1) + '_title'] = updatesAndInsightsData[index]['boxTitle'];
                            this['title_' + index.substr(-1, 1)] = updatesAndInsightsData[index]['title'];
                            this['body_' + index.substr(-1, 1)] = updatesAndInsightsData[index]['body'];
                        });
                        this.num_boxes = this.updates_insights.length;
                        event_bus.$emit('archive_name', this.archive_name);
                    }
                });
            },
            closeUpdatesInsights() {
                const vueInstance = this;
                this.showUpdatesInsights = false;
                event_bus.$emit('hide_chatGPT', true);
                setTimeout(function () {
                    vueInstance.editUpdatesInsights = false;
                }, 1000);
            }
        },
        watch:{
            num_boxes(){
                this.updateBoxClasses();
            }
        }
    }
</script>
<style lang="scss">
    @import '~@/_variables.scss';
    div.updates-and-insights{
        position:relative;
        &.chatGPT{
            min-height:30rem;
        }
        fieldset.bordered {
            border-radius:2rem;
            padding: 0 1.4em 1.4em 1.4em !important;
            margin: 0 0 1.5em 0 !important;
            h4{
                color:$text-gray1;
            }
            &.card1{
                border: 0.2rem groove $light-blue !important;
                legend{
                    color:$light-blue;
                }
                h1{
                    color:$light-blue;
                }
            }
            &.card2{
                border: 0.2rem groove $black-blue !important;
                legend{
                    color:$black-blue;
                }
                h1{
                    color:$black-blue;
                }
            }
            &.card3{
                border: 0.2rem groove $gold !important;
                legend{
                    color:$gold;
                }
                h1{
                    color:$gold;
                }
            }
            &.card4{
                border: 0.2rem groove $dark-orange !important;
                legend{
                    color:$dark-orange;
                }
                h1{
                    color:$dark-orange;
                }
                h4{
                    color:$dark-orange;
                }
            }
        }
        legend.bordered {
            font-size: 1.2em !important;
            font-weight: bold !important;
            text-align: center !important;
            width:auto;
            padding:0 1rem;
            border-bottom:none;
            &.empty{
                padding:0;
            }
        }
        div.row.bordered{
            border:solid 1px;
            border-radius: 4px;
            min-height: 50px;
        }
        .insight-title{
            @media screen and (max-width: 500px) {
                font-size:2rem;
            }
        }
        .h7{
            font-size:12px;
        }
        .gap-10{
            gap:10px;
        }
        div.scrolling{
            max-height: 300px;
            overflow:auto;
        }
        .spinner.element-spinner.chatGPT{
            width:96% !important;
            height:100% !important;
            opacity:0.8 !important;
            top:0 !important;
        }
        .spinner-aux{
            position:absolute;
            width:96% !important;
            height:2000% !important;
            opacity:0.8 !important;
            background-color:white;
            top:100% !important;
            z-index:9999;
        }
    }
</style>
